import CryptoJS from 'crypto-js'; // 引用AES源码js

// eslint-disable-next-line import/no-cycle
import { getCryptoKey, setCryptoKey } from '@/tool/profile';

import { secret } from './config';

const calculateIV = key => {
  const base64String = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(key));
  return base64String.slice(0, 16);
};

// 默认密钥解密方法
const decryptDefault = content => {
  const defaultKey = CryptoJS.enc.Utf8.parse(secret);
  const defaultIv = CryptoJS.enc.Utf8.parse(calculateIV(secret));

  const encryptedHexStr = CryptoJS.enc.Hex.parse(content);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, defaultKey, {
    iv: defaultIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};

// 获取解密后的自定义密钥 (使用系统默认密钥进行解密)
const customKey = getCryptoKey() !== '' ? decryptDefault(getCryptoKey()) : secret;
let key = CryptoJS.enc.Utf8.parse(customKey); // 十六位十六进制数作为密钥
let iv = CryptoJS.enc.Utf8.parse(calculateIV(customKey)); // 十六位十六进制数作为密钥偏移量

// 设置自定义密钥
export const setCustomSecret = customSecret => {
  setCryptoKey(customSecret);
  const newSecret = decryptDefault(customSecret);
  key = CryptoJS.enc.Utf8.parse(newSecret);
  iv = CryptoJS.enc.Utf8.parse(calculateIV(newSecret));
};

// 重置自定义密钥
export const resetCustomSecret = () => {
  key = CryptoJS.enc.Utf8.parse(secret);
  iv = CryptoJS.enc.Utf8.parse(calculateIV(secret));
};

// 解密方法
export const decrypt = content => {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(content);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};

// 加密方法
export const encrypt = content => {
  // console.warn(calculateIV(secret));
  const srcs = CryptoJS.enc.Utf8.parse(content);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString().toUpperCase();
};

// 摘要方法
export const digest = content => {
  const base64Content = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(content));
  const timestamp = new Date().getTime();
  const md5 = CryptoJS.MD5(base64Content + timestamp + secret).toString();
  return `content=${base64Content}&timestamp=${timestamp}&digest=${md5}`;
};

// TODO: 大小写未同意，目前aes加密结果为强制转为大写（大小写不敏感），md5结果为默认小写（大小写敏感，后台比对已经忽略大小写）；
